import React from 'react';
import { StarFilled } from '@ant-design/icons';
import styled from 'styled-components';
import { render } from '@testing-library/react';

const StarWraper = styled.span`

    margin: 0 5px;
    & > span > svg {
        display: flex;
    }
    &:hover{
        cursor: pointer
    }
`
class FavoriteStar extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = { value: props.initialValue || false }
    }

    onClick = (event) => {
        this.props.onClick(event);
        this.setState({ value: !this.state.value }, this.onChange);
    }

    onChange = () => {
        this.props.onChange(this.state.value) 
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.initialValue !== this.state.value) {
            this.setState({value: nextProps.initialValue})
        }
    }


    render() {
        return (
            <StarWraper onClick={this.onClick}>
                <StarFilled style={{ color: this.state.value ? '#f0b90b' : 'rgba(0,0,0,.65)' }} />
            </StarWraper>
        )
    }
}

export default FavoriteStar;

